import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import initPage from "../../../utils/initPage";
import useApi from "../../../services/api";

import Template from "../../../template/template";
import Header from "../header/header";
import { useCallback } from "react";

import "./styles.css";

function Response() {
  initPage({ title: "" });

  const { id } = useParams();
  const [vote, setVote] = useState(null);

  const { ApiGetFaqArticle, ApiCreateFaqVote } = useApi();

  const [article, setArticle] = useState(null);

  async function getArticle() {
    const { data } = await ApiGetFaqArticle(id);

    setArticle(data);
    setVote(data.vote);
  }

  useEffect(() => {
    getArticle();
  }, [id]);

  const handleVote = useCallback(
    (newVote) => {
      const voteNull = newVote === vote;

      if (voteNull) {
        ApiCreateFaqVote({
          faq_id: article.id,
          vote: null,
        });

        setVote(null);
      } else {
        ApiCreateFaqVote({
          faq_id: article.id,
          vote: newVote,
        });

        setVote(newVote);
      }
    },
    [ApiCreateFaqVote, article, vote],
  );

  return (
    <Template>
      {article && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="support-warp">
                <div className="support-warp-main">
                  <Header />

                  <div className="support-content">
                    {/* <div className="support-search">
                    <h4>PESQUISAR NA CENTRAL DE SUPORTE</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                    <div className="support-article">
                      <div className="support-article-header">
                        <h1>{article.title}</h1>
                      </div>

                      <div className="single-article">
                        <div
                          style={{ fontSize: 18, color: "#323232" }}
                          className="intro"
                          dangerouslySetInnerHTML={{ __html: article.response }}
                        />
                        <div class="article-like">
                          <h6>{t("Support.Solve")}</h6>
                          <div
                            onClick={() => handleVote("like")}
                            class={
                              vote === "like"
                                ? "like-btn thumb-up cursor-pointer active"
                                : "like-btn thumb-up cursor-pointer"
                            }
                          >
                            {t("Support.Yes")} <i class="fal fa-thumbs-up"></i>
                          </div>
                          <div
                            onClick={() => handleVote("dislike")}
                            class={
                              vote === "dislike"
                                ? "like-btn thumb-down cursor-pointer active"
                                : "like-btn thumb-down cursor-pointer"
                            }
                          >
                            {t("Support.Not")} <i class="fal fa-thumbs-down"></i>
                          </div>
                        </div>
                      </div>
                      <div className="support-article-side">
                        <div className="article-side-inner">
                          <h4>{t("Article.Relateds")}</h4>
                          <ul className="article-list">
                            {article?.relateds.map((R) => {
                              return (
                                <li>
                                  <p>
                                    <Link to={DefRoutes.ResponseFaq.replace(":id", R.id)}>{R.title}</Link>
                                  </p>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="support-bot">
                      <div className="intro-box">
                        <h3>{t("Article.NotFind")}</h3>
                        <p>{t("Article.Description")}</p>
                      </div>
                      <div className="intro-button-box">
                        <a href={DefRoutes.Request} className="btn btn-primary">
                          {t("Article.Action")}{" "}
                          <span className="icon">
                            <img src="/images/support-w-ico.png" alt="" />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Template>
  );
}

export default Response;
